import React, { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { FilePdf, FileXls } from "@phosphor-icons/react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

async function downloadWithAuth(url, filename) {
  const res = await fetch(url, { credentials: "include" });
  if (!res.ok) throw new Error("Gagal mengunduh");
  const blob = await res.blob();
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob); a.download = filename; document.body.appendChild(a); a.click(); a.remove();
}

export default function Laporan() {
  const [modul, setModul] = useState("absensi");
  const [modulList, setModulList] = useState([]);
  const [master, setMaster] = useState({ kelas: [], kamar: [], halaqah: [] });
  const [filter, setFilter] = useState({ from: "", to: "", kelas_id: "", kamar_id: "", halaqah_id: "" });
  const [preset, setPreset] = useState("bulan");
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const [k, ka, h, ml] = await Promise.all([
          api.get("/master/kelas"), api.get("/master/kamar"), api.get("/master/halaqah"),
          api.get("/laporan/modul-list"),
        ]);
        setMaster({ kelas: k.data, kamar: ka.data, halaqah: h.data });
        setModulList(ml.data);
      } catch (_) {}
    })();
  }, []);

  const applyPreset = (p) => {
    setPreset(p);
    const today = new Date();
    const iso = (d) => d.toISOString().slice(0, 10);
    if (p === "hari") setFilter((f) => ({ ...f, from: iso(today), to: iso(today) }));
    if (p === "minggu") {
      const start = new Date(today); start.setDate(today.getDate() - 6);
      setFilter((f) => ({ ...f, from: iso(start), to: iso(today) }));
    }
    if (p === "bulan") {
      const start = new Date(today.getFullYear(), today.getMonth(), 1);
      setFilter((f) => ({ ...f, from: iso(start), to: iso(today) }));
    }
    if (p === "tahun") {
      const start = new Date(today.getFullYear(), 0, 1);
      setFilter((f) => ({ ...f, from: iso(start), to: iso(today) }));
    }
  };

  useEffect(() => { applyPreset("bulan"); }, []);

  const load = async () => {
    try {
      const params = {
        modul,
        tanggal_from: filter.from || undefined,
        tanggal_to: filter.to || undefined,
        kelas_id: filter.kelas_id || undefined,
        kamar_id: filter.kamar_id || undefined,
        halaqah_id: filter.halaqah_id || undefined,
      };
      const { data } = await api.get("/laporan/rekap", { params });
      setItems(data.items);
    } catch (e) { toast.error(e.response?.data?.detail || e.message); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [modul, filter]);

  const params = useMemo(() => {
    const p = new URLSearchParams({ modul });
    if (filter.from) p.set("tanggal_from", filter.from);
    if (filter.to) p.set("tanggal_to", filter.to);
    if (filter.kelas_id) p.set("kelas_id", filter.kelas_id);
    if (filter.kamar_id) p.set("kamar_id", filter.kamar_id);
    if (filter.halaqah_id) p.set("halaqah_id", filter.halaqah_id);
    return p.toString();
  }, [modul, filter]);

  const cols = useMemo(() => {
    if (items.length === 0) return [];
    const c = Object.keys(items[0]).filter((k) => !["id", "petugas_id", "guru_id", "santri_id", "jenis_id", "kegiatan_id", "halaqah_id", "created_at", "updated_at"].includes(k));
    return c.slice(0, 8);
  }, [items]);

  return (
    <div className="space-y-5">
      <div>
        <div className="text-xs uppercase tracking-widest text-slate-400">Rekap</div>
        <h1 className="font-display text-3xl font-bold text-[#064E3B]">Laporan & Rekap</h1>
      </div>

      <div className="imsyaf-card p-5 space-y-4">
        <div className="flex flex-wrap gap-2">
          {["hari", "minggu", "bulan", "tahun"].map((p) => (
            <button key={p} onClick={() => applyPreset(p)} data-testid={`preset-${p}`}
              className={`imsyaf-btn ${preset === p ? "bg-[#14532d] text-white" : "border border-green-900/20 text-green-900"}`}>{p.toUpperCase()}</button>
          ))}
        </div>
        <div className="grid md:grid-cols-6 gap-3">
          <div><label className="text-xs">Modul</label>
            <select className="imsyaf-input" value={modul} onChange={(e) => setModul(e.target.value)} data-testid="rekap-modul">
              {modulList.map((m) => <option key={m.key} value={m.key}>{m.label}</option>)}
            </select></div>
          <div><label className="text-xs">Dari</label><input type="date" className="imsyaf-input" value={filter.from} onChange={(e) => setFilter({ ...filter, from: e.target.value })} data-testid="rekap-from" /></div>
          <div><label className="text-xs">Sampai</label><input type="date" className="imsyaf-input" value={filter.to} onChange={(e) => setFilter({ ...filter, to: e.target.value })} data-testid="rekap-to" /></div>
          <div><label className="text-xs">Kelas</label>
            <select className="imsyaf-input" value={filter.kelas_id} onChange={(e) => setFilter({ ...filter, kelas_id: e.target.value })}>
              <option value="">Semua</option>{master.kelas.map((k) => <option key={k.id} value={k.id}>{k.nama}</option>)}
            </select></div>
          <div><label className="text-xs">Kamar</label>
            <select className="imsyaf-input" value={filter.kamar_id} onChange={(e) => setFilter({ ...filter, kamar_id: e.target.value })}>
              <option value="">Semua</option>{master.kamar.map((k) => <option key={k.id} value={k.id}>{k.nama}</option>)}
            </select></div>
          <div><label className="text-xs">Halaqah</label>
            <select className="imsyaf-input" value={filter.halaqah_id} onChange={(e) => setFilter({ ...filter, halaqah_id: e.target.value })}>
              <option value="">Semua</option>{master.halaqah.map((k) => <option key={k.id} value={k.id}>{k.nama}</option>)}
            </select></div>
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            className="imsyaf-btn-outline"
            data-testid="rekap-pdf-btn"
            onClick={() => downloadWithAuth(`${BACKEND_URL}/api/laporan/rekap.pdf?${params}`, `rekap_${modul}.pdf`).catch((e) => toast.error(e.message))}
          ><FilePdf size={16}/> Unduh PDF</button>
          <button
            className="imsyaf-btn-outline"
            data-testid="rekap-xlsx-btn"
            onClick={() => downloadWithAuth(`${BACKEND_URL}/api/laporan/rekap.xlsx?${params}`, `rekap_${modul}.xlsx`).catch((e) => toast.error(e.message))}
          ><FileXls size={16}/> Unduh Excel</button>
        </div>
      </div>

      <div className="imsyaf-card p-3 text-sm text-slate-500">Total: <b>{items.length}</b> baris</div>

      <div className="imsyaf-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-xs zebra">
            <thead className="bg-slate-50"><tr>{cols.map((c) => <th key={c} className="text-left px-3 py-2 font-semibold whitespace-nowrap">{c}</th>)}</tr></thead>
            <tbody>{items.slice(0, 300).map((r, i) => (
              <tr key={i} className="border-t border-slate-100">{cols.map((c) => <td key={c} className="px-3 py-1.5 whitespace-nowrap">{String(r[c] ?? "—")}</td>)}</tr>
            ))}
            {items.length === 0 && <tr><td colSpan={cols.length || 1} className="text-center py-8 text-slate-400">Belum ada data.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
